var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","small":"","disabled":_vm.loading},on:{"click":_vm.submit}},[(_vm.upvote)?_c('v-icon',[_vm._v("arrow_drop_up")]):_c('v-icon',[_vm._v("arrow_drop_down")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }